import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GeneralModule } from '../general/general.module';
import { SmartCardCommunicationService } from './services/smart-card-communication.service';
import { SmartCardConnectionHttpService } from './services/smart-card-connection-http.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    GeneralModule,
  ],
  declarations: [
  ],
  providers: [
    SmartCardCommunicationService,
    SmartCardConnectionHttpService,
  ]
})
export class SmartCardModule { }
